// extracted by mini-css-extract-plugin
export default {"container":"Zr-z","heading":"_r-z","text":"as-z","info":"bs-z","link":"cs-z","fullMaxWidth":"ds-z"};